import { IWPImage } from "@/src/types";
import { MainSection } from "@/styles/global";
import React from "react";
import S from "./ImageBlock.styled";
import { toGatsbyImage } from "@/src/helpers";
import { Scrollbar, FreeMode, Mousewheel } from "swiper/modules";
import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "swiper/css";
import "swiper/css/scrollbar";

SwiperCore.use([Scrollbar]);

export interface ImageBlockProps {
  images: {
    image: IWPImage;
  }[];
}

const ImageBlock: React.FC<ImageBlockProps> = ({ images }) => {
  const imageData1 = toGatsbyImage(images[0].image);
  const imageData2 = toGatsbyImage(images[1].image);
  const imageData3 = toGatsbyImage(images[2].image);

  return (
    <MainSection>
      <S.ImagesWrapper>
        <Swiper
          modules={[Scrollbar, FreeMode, Mousewheel]}
          className="mySwiper"
          spaceBetween={16}
          mousewheel={{
            forceToAxis: true,
          }}
          slidesPerView={"auto"}
        >
          <SwiperSlide>
            {imageData1 && (
              <S.Image
                image={imageData1}
                alt={images[0].image.altText || ""}
                className="image-1"
              />
            )}
          </SwiperSlide>
          <SwiperSlide>
            {imageData2 && (
              <S.Image image={imageData2} alt={images[1].image.altText || ""} />
            )}
          </SwiperSlide>
          <SwiperSlide>
            {imageData3 && (
              <S.Image image={imageData3} alt={images[2].image.altText || ""} />
            )}
          </SwiperSlide>
        </Swiper>
      </S.ImagesWrapper>
    </MainSection>
  );
};

export default ImageBlock;
